module.exports = __webpack_public_path__ + "img/australia-stomach-cancer-male.fa890f21.png";